import type { ReactNode } from "react";

import { SkeletonLines } from "./Skeleton";

export interface ChartCardProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly source?: string;
  readonly action?: ReactNode;
  readonly loading?: boolean;
  readonly className?: string;
  readonly children: ReactNode;
}

// Standard titled panel. Centralizes the header layout (title + subtitle + source/action) and the
// loading skeleton so every surface's panels are consistent.
export const ChartCard = ({
  title,
  subtitle,
  source,
  action,
  loading,
  className,
  children,
}: ChartCardProps): ReactNode => (
  <section className={className ? `card ${className}` : "card"}>
    <div className="card-head">
      <div>
        <div className="card-title">{title}</div>
        {subtitle ? <div className="card-subtitle">{subtitle}</div> : null}
      </div>
      {action ?? (source ? <span className="card-source">{source}</span> : null)}
    </div>
    {loading ? <SkeletonLines count={4} /> : children}
  </section>
);
